export enum CustodyAccountOpeningStep {
	PRESCREEN = "prescreen",
	NOT_VERIFIED = "sumsub-steps-involved",
	ELIGIBLE = "personal-data-tax-info",
	MISSING_REQUIRED_DATA = "missing-data",
	NOT_ELIGIBLE = "not-eligible"
}
